import { Plus, Languages } from "lucide-react";
import { CHANNELS, capitalize, daysLeft } from "./shared";

export function TranslatorSessionList({ sessions, activeId, onSelect, onNew, showOwner }) {
  return (
    <div className="border-2 border-black bg-white flex flex-col min-h-0" data-testid="translator-session-list">
      <div className="p-4 border-b-2 border-black flex items-center justify-between gap-2">
        <div className="font-display font-bold text-base">Conversaciones</div>
        <button
          onClick={onNew}
          data-testid="translator-new-session-btn"
          className="inline-flex items-center gap-1.5 bg-[#E63946] text-white text-xs font-semibold uppercase tracking-wider px-3 py-2 hover:bg-black transition-colors"
        >
          <Plus size={14} /> Nueva
        </button>
      </div>
      <div className="overflow-y-auto flex-1 divide-y divide-zinc-200">
        {sessions.length === 0 && (
          <div className="p-6 text-sm text-zinc-500 text-center" data-testid="translator-empty-list">
            <Languages className="mx-auto mb-2 text-zinc-400" size={28} />
            Sin conversaciones. Pulsa «Nueva» para empezar.
          </div>
        )}
        {sessions.map((s) => {
          const ch = CHANNELS[s.channel] || CHANNELS.otro;
          const active = s.id === activeId;
          return (
            <button
              key={s.id}
              onClick={() => onSelect(s.id)}
              data-testid={`translator-session-${s.id}`}
              className={`w-full text-left p-4 transition-colors ${active ? "bg-zinc-900 text-white" : "hover:bg-zinc-50"}`}
            >
              <div className="flex items-center justify-between gap-2">
                <span className="font-semibold text-sm truncate">{s.client_name}</span>
                <span className={`text-[10px] font-bold uppercase px-1.5 py-0.5 ${active ? "bg-white text-black" : "bg-black text-white"}`}>
                  {s.client_lang}
                </span>
              </div>
              <div className={`text-xs truncate mt-1 ${active ? "text-zinc-300" : "text-zinc-500"}`}>
                {s.last_message || "Sin mensajes"}
              </div>
              <div className={`flex items-center gap-2 text-[10px] uppercase tracking-wider mt-2 ${active ? "text-zinc-400" : "text-zinc-400"}`}>
                <ch.Icon size={11} /> {ch.label} · {capitalize(s.client_lang_name)} · se borra en {daysLeft(s.expires_at)}d
              </div>
              {showOwner && s.owner_name && (
                <div className="text-[10px] mt-1 text-zinc-400">Creada por {s.owner_name}</div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
